<div class="gallery-lightbox-wrapper">

  <button mat-icon-button (click)="closeDialog()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>

  <!-- SWIPER CONTAINER -->
  <div #gallerySwiper class="swiper-container full-screen-swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let item of mediaItems">

        <ng-container [ngSwitch]="item.resourceType">

          <!-- Case 1: IMAGE -->
          <img *ngSwitchCase="'IMAGE'"
               [src]="item.resourceUrl"
               alt="Gallery Image"
               class="media-content">

          <!-- Case 2: LOCAL VIDEO (URL is the source, poster is the thumbnail) -->
          <video *ngSwitchCase="'VIDEO'"
                 [src]="item.resourceUrl"
                 controls
                 autoplay
                 playsinline
                 class="media-content">
            Your browser does not support the video tag.
          </video>

          <!-- Case 3: UNSUPPORTED/DEFAULT -->
          <div *ngSwitchDefault>Unsupported Media</div>
        </ng-container>
      </div>
    </div>

    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-pagination"></div>

  </div>
</div>
